import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import {
  fetchAuctionAsync,
  setBargiryDate,
  setCalenderBargiryShow,
  setCalenderTakhliehShow,
  setTakhliehDate,
} from "../../redux/newRequest/newRequest.actions";
import { DatePickerItemStyled } from "./datePickerItem.styles";

import {
  selectNewRequestBargiryDate,
  selectNewRequestCalenderBargiry_show,
  // selectNewRequesttakhliehDate,
  selectNewRequestCalenderTakhlieh_show,
  selectNewRequestTakhliehDate,
} from "../../redux/newRequest/newRequest.selectors";
import socket from "../../assets/socketConnection";

const DatePickerItem = ({
  info,
  title,
  subTitle,
  day,
  setBargiryDate,
  setTakhliehDate,

  selectNewRequestBargiryTime,
  selectNewRequestBargiryDate,

  setCalenderBargiryShow,
  selectNewRequestTakhliehDate,
  selectNewRequestCalenderBargiry_show,
  selectNewRequestCalenderTakhlieh_show,

  setCalenderTakhliehShow,

  fetchAuctionAsync,

  ...others
}) => {
  const handle_item_click = () => {
    // alert("hi");
    if (selectNewRequestCalenderBargiry_show) {
      setBargiryDate(info);
      setTimeout(() => {
        setCalenderBargiryShow(false);
        fetchAuctionAsync(socket);
      }, 300);
      return;
    }

    if (selectNewRequestCalenderTakhlieh_show) {
      setTakhliehDate(info);
      setTimeout(() => {
        setCalenderTakhliehShow(false);
        // debugger;
      }, 300);
      return;
    }
  };

  // console.log(selectNewRequestBargiryDate.value);
  // console.log(info.value);
  // debugger;
  return (
    <DatePickerItemStyled
      selectNewRequestBargiryDate={
        selectNewRequestBargiryDate.value === info.value
      }
      selectNewRequestTakhliehDate={
        selectNewRequestTakhliehDate.value === info.value
      }
      selectNewRequestCalenderBargiry_show={
        selectNewRequestCalenderBargiry_show
      }
      selectNewRequestCalenderTakhlieh_show={
        selectNewRequestCalenderTakhlieh_show
      }
      onClick={handle_item_click}
      {...others}
    >
      <div>{title}</div>
      <div>{subTitle}</div>
    </DatePickerItemStyled>
  );
};

const mapStateToProps = createStructuredSelector({
  selectNewRequestBargiryDate: selectNewRequestBargiryDate,
  selectNewRequestTakhliehDate: selectNewRequestTakhliehDate,

  selectNewRequestCalenderBargiry_show: selectNewRequestCalenderBargiry_show,
  selectNewRequestCalenderTakhlieh_show: selectNewRequestCalenderTakhlieh_show,
});

const mapDispatchToProps = (dispatch) => ({
  setBargiryDate: (x) => dispatch(setBargiryDate(x)),
  setCalenderBargiryShow: (x) => dispatch(setCalenderBargiryShow(x)),

  setTakhliehDate: (x) => dispatch(setTakhliehDate(x)),
  setCalenderTakhliehShow: (x) => dispatch(setCalenderTakhliehShow(x)),

  fetchAuctionAsync: (x) => dispatch(fetchAuctionAsync(x)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DatePickerItem);
